// types
import { ReportColumnDto } from 'src/api';
// constants
import { singleSelectAggregationModels } from '../constants/aggregation-model/single-select';

export function FrequencyColumn(index: number) {
  const column = {
    field: 'frequency',
    headerName: 'Frequency',
    description: 'Membership frequency column',
    type: 'singleSelect',
    valueOptions: [
      'Yearly',
      'Half yearly',
      'Quarterly',
      'Monthly',
      'Weekly',
      'Bi weekly',
      'Tri weekly',
      'Every fourth week',
      'Every twelfth week',
      'Drop in',
      'One time',
      'Voucher',
      'Never',
    ],
    index,
    width: 150,
    groupable: true,
    availableAggregationFunctions: singleSelectAggregationModels,
    headerAlign: 'center',
    align: 'center',
  } as ReportColumnDto<any, any, any>;
  return column;
}
